import { withLoading } from '@adjust/dashboard-components';
import { connectWithStore } from '@react/Common/connectWithStore';
import { ListComponent } from '@react/Common/List';
import { getPartnerName } from '@react/constants/historyEvent/utils';
import { getPartnerState, togglePartner, fetchPartnerListWithAccessDetails } from '@redux/ducks/partner/partner';
import { selectCurrentPartner } from '@redux/ducks/userPermissions/userPermissions';

const mapStateToProps = state => {
  const { partnerList, searchTerm, isLoading } = getPartnerState(state);

  return {
    isLoading,
    searchTerm,
    list: partnerList,
    emptyListMessage: t('users.no-partners.message'),
    chooseItemName: partner => getPartnerName(partner),
    chooseItemId: partner => partner.id,
  };
};

const mapStateToDispatch = {
  toggleItem: togglePartner,
  onItemClick: selectCurrentPartner,
  fetchListWithAccessDetails: fetchPartnerListWithAccessDetails,
};

const ListComponentWithLoading = withLoading(ListComponent, true);

export const PartnerList = connectWithStore(mapStateToProps, mapStateToDispatch)(ListComponentWithLoading);
